<form [formGroup]="form">
  <div class="switch">
    <label>
      <input
        type="checkbox"
        formControlName="includePrintedName"
        [(ngModel)]="signatureDataEntity.includePrintedName"
      />
      Include Printed Name
    </label>
  </div>
</form>
